<template>
    <div class="upload-component">
      <form @submit.prevent="handleSubmit" class="asset-form">
        <!-- 资产类型 -->
        <div class="form-group">
          <label for="assetType">资产类型：</label>
          <select id="assetType" v-model="assetInfo.type" required>
            <option value="">请选择</option>
            <option value="农用地">农用地</option>
            <option value="建设用地">建设用地</option>
            <option value="未利用地">未利用地</option>
            <option value="其他用地">其他用地</option>
            <option value="住宅用地">住宅用地</option>
            <option value="商业用房">商业用房</option>
            <option value="工业用房">工业用房</option>
            <option value="其他用房">其他用房</option>
          </select>
        </div>
  
        <!-- 出租/出售 -->
        <div class="form-group">
          <label>交易方式：</label>
          <div class="radio-group">
            <label class="radio-option">
              <input
                type="radio"
                v-model="assetInfo.transactionType"
                value="出租"
                required
              />
              <span>出租</span>
            </label>
            <label class="radio-option">
              <input
                type="radio"
                v-model="assetInfo.transactionType"
                value="出售"
                required
              />
              <span>出售</span>
            </label>
          </div>
        </div>
  
        <!-- 地址 -->
        <div class="form-group">
          <label for="address">地址：</label>
          <input
            type="text"
            id="address"
            v-model="assetInfo.address"
            placeholder="请输入资产地址"
            required
          />
        </div>
  
        <!-- 产权证 -->
        <div class="form-group">
          <label for="propertyCertificate">产权证号：</label>
          <input
            type="text"
            id="propertyCertificate"
            v-model="assetInfo.propertyCertificate"
            placeholder="请输入产权证号"
            required
          />
        </div>
  
        <!-- 房屋户型（仅适用于住宅用地和用房） -->
        <div class="form-group" v-if="isHouseType">
          <label for="houseLayout">房屋户型：</label>
          <input
            type="text"
            id="houseLayout"
            v-model="assetInfo.houseLayout"
            placeholder="请输入房屋户型（如：3室2厅1卫）"
          />
        </div>
  
        <!-- 面积 -->
        <div class="form-group">
          <label for="area">面积（㎡）：</label>
          <input
            type="number"
            id="area"
            v-model="assetInfo.area"
            placeholder="请输入面积"
            required
          />
        </div>
  
        <!-- 价格 -->
        <div class="form-group">
          <label for="price">价格（元）：</label>
          <input
            type="number"
            id="price"
            v-model="assetInfo.price"
            placeholder="请输入价格"
            required
          />
        </div>
  
        <!-- 亮点 -->
        <div class="form-group">
          <label for="highlights">亮点：</label>
          <textarea
            id="highlights"
            v-model="assetInfo.highlights"
            placeholder="请输入资产亮点（如：交通便利、环境优美等）"
            rows="4"
          ></textarea>
        </div>
  
        <!-- 提交按钮 -->
        <div class="form-group full-width">
          <button type="submit">发布</button>
        </div>
      </form>
  
      <!-- 提交后的信息展示 -->
      <div v-if="submitted" class="submitted-info">
        <h3>已发布的资产信息</h3>
        <p><strong>资产类型：</strong>{{ assetInfo.type }}</p>
        <p><strong>交易方式：</strong>{{ assetInfo.transactionType }}</p>
        <p><strong>地址：</strong>{{ assetInfo.address }}</p>
        <p><strong>产权证号：</strong>{{ assetInfo.propertyCertificate }}</p>
        <p v-if="isHouseType"><strong>房屋户型：</strong>{{ assetInfo.houseLayout }}</p>
        <p><strong>面积：</strong>{{ assetInfo.area }} ㎡</p>
        <p><strong>价格：</strong>{{ assetInfo.price }} 元</p>
        <p><strong>亮点：</strong>{{ assetInfo.highlights }}</p>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent, ref, computed } from 'vue';
  
  export default defineComponent({
    name: 'UploadComponent',
    setup() {
      // 资产信息数据
      const assetInfo = ref({
        type: '', // 资产类型
        transactionType: '', // 交易方式（出租/出售）
        address: '', // 地址
        propertyCertificate: '', // 产权证号
        houseLayout: '', // 房屋户型
        area: '', // 面积
        price: '', // 价格
        highlights: '', // 亮点
      });
  
      // 是否已提交
      const submitted = ref(false);
  
      // 判断是否为住宅或用房类型
      const isHouseType = computed(() => {
        return (
          assetInfo.value.type === '住宅用地' ||
          assetInfo.value.type === '商业用房' ||
          assetInfo.value.type === '工业用房' ||
          assetInfo.value.type === '其他用房'
        );
      });
  
      // 提交表单
      const handleSubmit = () => {
        submitted.value = true;
        console.log('发布的资产信息：', assetInfo.value);
        alert('资产信息发布成功！');
      };
  
      return {
        assetInfo,
        submitted,
        isHouseType,
        handleSubmit,
      };
    },
  });
  </script>
  
  <style scoped>
  .upload-component {
    max-width: 600px;
    margin: 0 auto;
    padding: 20px;
    text-align: left;
  }
  
  .asset-form {
    background-color: #f9f9f9;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  
  .form-group {
    margin-bottom: 15px;
  }
  
  label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
  }
  
  input,
  select,
  textarea {
    width: 100%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
  }
  
  textarea {
    resize: vertical;
  }
  
  .radio-group {
    display: flex;
    gap: 10px;
  }
  
  .radio-option {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 5px;
    background-color: #f0f0f0;
    padding: 10px;
    border-radius: 4px;
    text-align: center;
  }
  
  .radio-option input {
    margin: 0;
    width: auto; /* 取消默认宽度 */
  }
  
  .radio-option span {
    white-space: nowrap; /* 防止文字换行 */
  }
  
  .full-width {
    width: 100%;
    text-align: center;
  }
  
  button {
    background-color: #42b983;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
    width: 100%;
  }
  
  button:hover {
    background-color: #369f6e;
  }
  
  .submitted-info {
    margin-top: 20px;
    padding: 20px;
    background-color: #f1f1f1;
    border-radius: 8px;
  }
  
  .submitted-info p {
    margin: 5px 0;
  }
  </style>